<template>
    <nav>
        <v-toolbar flat app color="primary">
            <v-toolbar-side-icon
                    class="white--text"
                    @click="drawer = !drawer"
                    v-if="!softBlock && userInfo && Object.keys(userInfo).length && userInfo.userID && (userInfo.importManager || userInfo.signatureManager || userInfo.outOfOfficeManager || userInfo.selectListManager || userInfo.workflowManager || userInfo.userManager || userInfo.docRepoManager || userInfo.smtpMailboxManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager)"
            ></v-toolbar-side-icon>

            <img src="../../../public/logoSimpleWhite.svg" width="180px" @click="userInfo && (userInfo.userID == 1 || userInfo.userID == 11) ? nav('syncStat') : ''">

            <v-layout row class="pl-2">
                <v-flex shrink>
                    <v-divider vertical></v-divider>
                </v-flex>
                <v-flex xs12 class="pl-2" v-if="userInfo">




                    <!--Incase you don't want real time updates to the live chat plugin when options are changed, use the below code snippet. Please note that each time you change the settings you will need to copy and paste the snippet code to your website-->
                    <!--<call-us
                    phonesystem-url="https://smitk.3cx.co.za:5001"
                    style="position:fixed;font-size:16px;line-height:17px;z-index: 99999;--call-us-main-accent-color:#e96106;--call-us-main-background-color:#FFFFFF;--call-us-plate-background-color:#ffffff;--call-us-plate-font-color:#000000;--call-us-main-font-color:#000000;--call-us-agent-bubble-color:#00000010;right: 20px; bottom: 20px;"
                    id="wp-live-chat-by-3CX"
                    minimized="true"
                    animation-style="noanimation"
                    party="LiveChat836156"
                    minimized-style="bubbleright"
                    allow-call="false"
                    allow-video="false"
                    allow-soundnotifications="true"
                    enable-mute="true"
                    enable-onmobile="true"
                    offline-enabled="true"
                    enable="true"
                    ignore-queueownership="false"
                    authentication="both"
                    operator-name="Tasklogix Support"
                    show-operator-actual-name="true"
                    aknowledge-received="true"
                    operator-icon="data:image/png;base64,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"
                    gdpr-enabled="false"
                    message-userinfo-format="both"
                    message-dateformat="both"
                    lang="en"
                    button-icon-type="default"
                    greeting-visibility="none"
                    greeting-offline-visibility="none"
                    chat-delay="2000"
                    enable-direct-call="false"
                    enable-ga="false"
                    ></call-us>-->


                    <v-layout row align-center v-show="userInfo && typeof userInfo.userID != 'undefined'">
<!--Dash-->
                        <v-flex class="px-1" shrink>
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('dashboard')"
                                        slot="activator"
                                >
                                    <v-badge
                                            overlap
                                            color="secondary"
                                            left
                                            class="mt-2"
                                    >
                                        <template slot="badge">
                                            <span class="white--text caption">{{notificationCount}}</span>
                                        </template>
<!--<v-icon @click="nav('dashboard')" large color="white" class="nav-item" >dashboard</v-icon>-->
                                        <img src="../../../public/icons/dashboard_white.svg" class="nav-item" width="32px">
                                    </v-badge>
                                </v-btn>
                                <span>Dashboard</span>
                            </v-tooltip>
                        </v-flex>
<!--SMTP-->
                        <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.smtpAddressEnabled === 1)">
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('smtp')"
                                        slot="activator"
                                >
<!--                                    <img src="../../../public/smtp.svg" class="nav-item" width="32px">-->
<!--                                    <v-icon large color="white">mail_outline</v-icon>-->
                                    <img src="../../../public/smtp_mail_multi.svg" class="nav-item" width="32px" style="height: 32px; width: 32px">
                                </v-btn>
                                <span>Mail</span>
                            </v-tooltip>
                        </v-flex>
<!--SMTP Mailboxes-->
                        <v-flex class="px-1 pt-1" shrink v-if="!softBlock && userInfo.mailboxes && Array.isArray(userInfo.mailboxes) && userInfo.mailboxes.length">
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('mailboxes')"
                                        slot="activator"
                                >
                                    <img src="../../../public/mailbox_multi.svg" class="nav-item" width="32px" style="height: 32px; width: 32px">
                                </v-btn>
                                <span>Group Mailboxes</span>
                            </v-tooltip>
                        </v-flex>
<!--Office-->
<!--                        <v-flex class="px-1 pt-1" shrink v-if="intToBool(userInfo.office365Enabled)">-->
<!--                            <v-tooltip bottom>-->
<!--                                <v-btn-->
<!--                                        icon-->
<!--                                        flat-->
<!--                                        large-->
<!--                                        color="white"-->
<!--                                        class="pa-0 ma-0"-->
<!--                                        @click="nav('mail')"-->
<!--                                        slot="activator"-->
<!--                                >-->
<!--                                    <img src="../../../public/outlook_32x1.svg" class="nav-item" >-->
<!--                                </v-btn>-->
<!--                                <span>Office 365</span>-->
<!--                            </v-tooltip>-->
<!--                        </v-flex>-->
                        <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.office365Enabled)">


                                <v-tooltip bottom>
                                    <template v-slot:activator="{on}">
                                        <v-btn
                                                icon
                                                flat
                                                large
                                                color="white"
                                                class="pa-0 ma-0"
                                                @click="nav('mail')"
                                                v-on="on"
                                        >
                                            <img src="../../../public/outlook_32x1.svg" class="nav-item" >

                                            <div style="position: absolute; right: 0; top: -5px" v-if="userInfo.office365Autolink && !userInfo.officeForwarderReady">
                                                <v-tooltip right>
                                                    <template v-slot:activator="{on}">
                                                        <v-icon small color="amber" v-on="on">
                                                            warning
                                                        </v-icon>
                                                    </template>
                                                    Warning Office 365 autolink rule has not been setup
                                                </v-tooltip>
                                            </div>
                                        </v-btn>
                                    </template>
                                    <span>Office 365</span>
                                </v-tooltip>
<!--                            <v-tooltip bottom>-->

<!--                                <v-btn-->
<!--                                        icon-->
<!--                                        flat-->
<!--                                        large-->
<!--                                        color="white"-->
<!--                                        class="pa-0 ma-0"-->
<!--                                        @click="nav('gmail')"-->
<!--                                        slot="activator"-->
<!--                                >-->
<!--                                    <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 32px">-->
<!--                                    <div style="position: absolute; right: 0; top: -12px" v-if="!userInfo.gmailForwarderReady">-->
<!--                                        <v-tooltip right>-->
<!--                                            <template v-slot:activator="{on}">-->
<!--                                                <v-icon small color="amber" v-on="on">-->
<!--                                                    warning-->
<!--                                                </v-icon>-->
<!--                                            </template>-->
<!--                                            Warning GMail autolink forwarder has not been setup-->
<!--                                        </v-tooltip>-->
<!--                                    </div>-->
<!--                                </v-btn>-->
<!--                                <span>Gmail</span>-->
<!--                            </v-tooltip>-->
                        </v-flex>
<!--Gmail-->
                        <v-flex class="px-1 pt-1" shrink v-if="!softBlock && intToBool(userInfo.gmailEnabled)">
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('gmail')"
                                        slot="activator"
                                >
                                    <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 32px">
                                    <div style="position: absolute; right: 0; top: -12px" v-if="!userInfo.gmailForwarderReady">
                                        <v-tooltip right>
                                            <template v-slot:activator="{on}">
                                                <v-icon small color="amber" v-on="on">
                                                    warning
                                                </v-icon>
                                            </template>
                                            Warning GMail autolink forwarder has not been setup
                                        </v-tooltip>
                                    </div>
                                </v-btn>
                                <span>Gmail</span>
                            </v-tooltip>
                        </v-flex>
<!--Tasks-->
                        <v-flex class="px-1" shrink>
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('tasks')"
                                        slot="activator"
                                >
                                    <div style="width: 32px; height:22.1px;">
                                        <img src="../../../public/icons/tasks_white.svg" class="nav-item reflow-image" >
                                    </div>

                                </v-btn>
                                <span>Tasks</span>
                            </v-tooltip>
                        </v-flex>
<!--Folders-->
                        <v-flex class="px-1" shrink>
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('folders')"
                                        slot="activator"
                                >
                                    <img src="../../../public/icons/folders.svg" class="nav-item" style="width: 32px">
                                </v-btn>
                                <span>Folders</span>
                            </v-tooltip>
                        </v-flex>
<!--Reports-->
                        <v-flex class="px-1" shrink v-if="typeof userInfo.reportsManager != 'undefined' && (intToBool(userInfo.reportsManager)) || intToBool(userInfo.reportsViewer)">
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('reporting')"
                                        slot="activator"
                                >
                                    <img src="../../../public/icons/reports_light.svg" style="width: 32px" class="nav-item"/>
                                </v-btn>
                                <span>Reports</span>
                            </v-tooltip>
                        </v-flex>

<!--Calendar View-->
                        <v-flex class="px-1 pt-1" shrink v-if="!softBlock && true">
                            <v-tooltip bottom>
                                <v-btn
                                        icon
                                        flat
                                        large
                                        color="white"
                                        class="pa-0 ma-0"
                                        @click="nav('calendar')"
                                        slot="activator"
                                >
                                    <img src="../../../public/icons/calendar.svg" class="nav-item" style="width: 32px">
                                </v-btn>
                                <span>Calendar View</span>
                            </v-tooltip>
                        </v-flex>
                      
<!--Browse Contacts View-->
                      <v-flex class="px-1 pt-1" shrink v-if="!softBlock && userInfo.entityInfo &&  userInfo.entityInfo.contactsEnabled">
                        <v-tooltip bottom>
                          <template #activator="{on}">
                            <v-btn
                                v-on="on"
                                icon
                                flat
                                large
                                color="white"
                                class="pa-0 ma-0"
                                @click="nav('contacts')"
                            >
                              <img src="../../../public/contacts.svg" class="nav-item" style="width: 28px">
                            </v-btn>
                          </template>
                          <span>Browse Contacts</span>
                        </v-tooltip>
                      </v-flex>

                        <template v-if="!softBlock && typeof userInfo.quickTasks != 'undefined' && userInfo.quickTasks.length > 0">
                            <v-divider vertical></v-divider>

                            <v-flex v-if="changingOrder" class="mx-2" xs12>
                                <v-progress-circular
                                        :size="36"
                                        :width="5"
                                        color="white"
                                        indeterminate
                                />
                            </v-flex>
<!--Quick Task-->
                            <v-flex class="ml-2 mr-2 smallwhiteScroll" xs12 v-else style="overflow-x: auto">
                                <div style="overflow-x: auto" class="smallwhiteScroll">
                                    <draggable
                                            :list="sortedQuickTasks"
                                            group="quickTasks"
                                            @start="drag=true"
                                            @end="drag=false"
                                            @change="log"
                                            ghostClass="ghost"
                                    >
                                        <div v-for="qTask in sortedQuickTasks" :key="qTask.id" class="px-1" style="float: left">

                                            <v-menu offset-y bottom center open-on-hover>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn
                                                            icon
                                                            flat
                                                            color="white"
                                                            class="pa-0 ma-0"
                                                            @click="quickTaskRun(qTask.config.workflow,qTask.config.folder)"
                                                            v-on="on"
                                                    >
                                                        <v-icon>{{qTask.config.icon}}</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-card class="white--text grey darken-2 pa-0 ma-0 py-1">
                                                    <v-layout row align-center class="text-xs-center">
                                                        <v-flex xs12 class="pr-1 pl-2">
                                                            {{qTask.config.description}}
                                                        </v-flex>
                                                        <v-flex shrink>
                                                            <v-btn
                                                                    icon
                                                                    flat
                                                                    small
                                                                    color="white"
                                                                    class="pa-0 ma-0"
                                                                    @click="editQuickTask = JSON.parse(JSON.stringify(qTask)); showEditQuickTask = true"
                                                            >
                                                                <v-icon small>edit</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                        <v-flex shrink>
                                                            <v-btn
                                                                    icon
                                                                    flat
                                                                    small
                                                                    color="red"
                                                                    class="pa-0 ma-0"
                                                                    @click="removeQuick(qTask)"
                                                            >
                                                                <v-icon small>close</v-icon>
                                                            </v-btn>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card>
                                            </v-menu>
                                        </div>
                                    </draggable>
                                </div>
                            </v-flex>
                        </template>
                    </v-layout>
                </v-flex>
            </v-layout>

<!--Announcement-->
<!--            <announcement/>-->

            <support-dialog/>

            <div class="mr-2">
                <v-tooltip bottom v-if="userInfo && userInfo.userID">
                    <template #activator="{on}">
                        <v-btn
                            icon
                            flat
                            large
                            color="white"
                            class="pa-0 ma-0"
                            @click="$store.state.showChat = !$store.state.showChat"
                            v-on="on"
                        >
                            <v-icon >{{$store.state.showChat ? 'speaker_notes_off' : 'chat'}}</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $store.state.showChat ? 'Hide support chat' : 'Show Support chat' }}</span>
                </v-tooltip>
            </div>



            <template v-if="userInfo && typeof userInfo.name != 'undefined'">
                <v-menu offset-x offset-overflow left nudge-left="6">
                    <v-avatar
                            color="secondary"
                            slot="activator"
                            :size="35"
                            style="cursor: pointer"
                            class="pa-0 ma-0"
                    >
                        <span class="white--text body-2">{{ getInitials(userInfo.name + ' ' + userInfo.surname) }}</span>
                    </v-avatar>
                    <v-card max-height="90vh" class="of-y">
                        <v-list dense>
                            
                            <v-list-tile
                                v-if="userInfo && userInfo.userProfiles && Array.isArray(userInfo.userProfiles)"
                                v-for="profile in profiles"
                                avatar
                                :key="profile.userId"
                                @click="gotoProfile(profile)"
                            >
                                <v-list-tile-avatar :size="32" :color="profile.active ? 'primary' : null">
                                    <v-icon
                                        :color="profile.active ? 'white' : 'primary'"
                                    >{{ profile.active ? 'person' : 'person_outline' }}</v-icon>
                                </v-list-tile-avatar>
                                
                                <v-list-tile-content :class="{
                                    'font-weight-bold' : profile.active
                                }">
                                    <v-list-tile-title v-html="profile.userName"></v-list-tile-title>
                                    <v-list-tile-sub-title v-html="profile.entityName"></v-list-tile-sub-title>
                                </v-list-tile-content>
                                
                                <v-list-tile-action>
                                    <v-btn
                                        v-if="!profile.active"
                                        flat icon color="error"
                                        small
                                        :loading="loadingProfile"
                                        :disabled="loadingProfile"
                                        @click.stop="removeProfile(profile)"
                                    >
                                        <v-icon>close</v-icon>
                                    </v-btn>
                                    <v-btn
                                        v-else
                                        flat icon color="primary"
                                        small
                                        @click.stop="addProfileUsername = null; addProfilePassword = null; showAddProfile = true"
                                    >
                                        <v-icon>add</v-icon>
                                    </v-btn>
                                </v-list-tile-action>
                            </v-list-tile>
                            
                            <v-divider></v-divider>
                            

                            <v-list-tile @click="logOff">
                                <v-list-tile-action>
                                    <v-icon color="primary">exit_to_app</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Sign Out
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile v-if="!softBlock && intToBool(userInfo.allowOutOfOfficeUpdate)" >
                                <v-switch
                                    v-model="outOfOffice"
                                    hide-details
                                    color="primary"
                                    class="pa-0 ma-0"
                                    label="Out of Office"
                                    ref="outOfOfficeSwitch"
                                    :loading="settingOOO"
                                    :disabled="settingOOO"
                                />
                            </v-list-tile>

                            <v-list-tile @click="showResetPassword = true">
                                <v-list-tile-action>
                                    <v-icon color="primary">vpn_key</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Change Password
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile @click="nav('twoFactor')">
                                <v-list-tile-action>
                                    <v-icon color="primary">verified_user</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Two Factor Authentication
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile v-if="!softBlock" @click="showDigest = true">
                                <v-list-tile-action>
                                    <v-icon color="primary">mail_outline</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Digest Options
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-divider v-if="!softBlock"></v-divider>
                            <v-list-tile v-if="!softBlock">
                                <v-switch
                                    v-model="$store.state.oPlugIgnore"
                                    hide-details
                                    color="primary"
                                    class="pa-0 ma-0"
                                    label="Ignore Office Plugin"
                                />
                            </v-list-tile>
                            <v-list-tile v-if="!softBlock" @click="oPlugCopyUrl">
                                <v-list-tile-action>
                                    <v-icon color="primary">content_copy</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Outlook Plugin URL
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-divider v-if="!softBlock"></v-divider>


                            <v-list-tile  v-if="!softBlock && userInfo">
                                <v-switch
                                        v-model="starOnCreate"
                                        hide-details
                                        color="primary"
                                        class="pa-0 ma-0"
                                        label="Star on Create Task"
                                        :loading="settingStarOnCreate"
                                        :disabled="settingStarOnCreate"
                                        ref="comSwitch"
                                />
                            </v-list-tile>
                            <v-list-tile v-if="!softBlock && userInfo">
                                <v-switch
                                    v-model="followOnCreate"
                                    hide-details
                                    color="primary"
                                    class="pa-0 ma-0"
                                    label="Follow on Create Task"
                                    :loading="settingfollowOnCreate"
                                    :disabled="settingfollowOnCreate"
                                    ref="comSwitch"
                                />
                            </v-list-tile>
                            <v-divider v-if="!softBlock"></v-divider>
<!--                            <v-list-tile v-if="typeof this.userInfo.taskView !== 'undefined'">-->
<!--                                <v-switch-->
<!--                                        v-model="taskViewVer"-->
<!--                                        hide-details-->
<!--                                        color="primary"-->
<!--                                        class="pa-0 ma-0"-->
<!--                                        label="Task Split View"-->
<!--                                        :loading="settingTaskViewVer"-->
<!--                                        :disabled="settingTaskViewVer"-->
<!--                                        ref="comSwitch"-->
<!--                                />-->
<!--                            </v-list-tile>-->
<!--                            <v-divider></v-divider>-->
                            <v-list-tile @click="resetSyncStatus">
                                <v-list-tile-action>
                                    <v-icon color="primary">sync</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Reset Local Data
                                </v-list-tile-content>
                            </v-list-tile>
                            <template  v-if="!softBlock && userInfo && userInfo.bulkSmsEnabled">
                                <v-divider></v-divider>

                                <v-list-tile @click="showSMSProfile = true">
                                    <v-list-tile-action>
                                        <v-icon color="primary">phone</v-icon>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        Bulk Sms Credits
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>

                            <v-divider v-if="!softBlock"></v-divider><v-divider v-if="!softBlock"></v-divider>

                            <v-list-tile v-if="!softBlock" @click="copyText(document, `${userInfo.entityInfo.smtpKey}-link@mail.tasklogix.co.za`); $snack.info('Autolink Address Copied')">
                                <v-list-tile-action>
                                    <v-icon color="primary">content_copy</v-icon>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Copy Autolink Address
                                </v-list-tile-content>
                            </v-list-tile>

                            <template v-if="!softBlock && userInfo && userInfo.smtpAddressEnabled === 1">
                                <v-list-tile @click="showSMTPSettings = true">
                                    <v-list-tile-action>
                                        <img src="../../../public/smtp.svg" class="nav-item" width="18px">
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        SMTP Mail Settings
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>

                            <v-list-tile v-if="userInfo && intToBool(userInfo.gmailEnabled)" @click="showRemoveGmailAccess = true">
                                <v-list-tile-action>
                                    <img src="../../../public/icons/gmail.svg" class="nav-item" style="width: 24px">
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Remove Account
                                </v-list-tile-content>
                            </v-list-tile>

                            <v-list-tile v-if="userInfo && intToBool(userInfo.office365Enabled)" @click="showRemoveOfficeAccess = true">
                                <v-list-tile-action>
                                    <img src="../../../public/outlook_32x1.svg" style="width: 24px"/>
                                </v-list-tile-action>
                                <v-list-tile-content>
                                    Remove Account
                                </v-list-tile-content>
                            </v-list-tile>

                            <template v-if="!softBlock && userInfo && intToBool(userInfo.office365Enabled)" >
                                <v-list-tile @click="showManageSendAs = true">
                                    <v-list-tile-action>
                                        <img src="../../../public/outlook_32x1.svg" style="width: 24px"/>
                                    </v-list-tile-action>
                                    <v-list-tile-content>
                                        Manage Send As
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>

                            <v-list-tile  v-if="!softBlock && userInfo && intToBool(userInfo.office365Enabled)" >
                                <v-switch
                                        color="primary"
                                        class="pa-0 ma-0"
                                        label="Office 365 Autolink"
                                        v-model="userInfo.office365Autolink"
                                        @change="updateO365AutoLink($event)"
                                        hide-details
                                ></v-switch>

                            </v-list-tile>

                        </v-list>
                    </v-card>
                </v-menu>

                <app-reset-password-dlg
                        :show-dialog="showResetPassword"
                        title="Reset Password"
                        body="Password must include a minimum of 6 characters and have at least one uppercase, lowercase and special character"
                        :cancel-button="true"
                        :buttons="['Reset Password']"
                        :call-backs="[ resetPassword ]"
                        @dismiss="showResetPassword = false"
                />
            </template>



        </v-toolbar>

        <v-navigation-drawer
                temporary
                v-model="drawer"
                app
                class="white"
                v-if="userInfo && userInfo.userID && (userInfo.importManager || userInfo.signatureManager || userInfo.outOfOfficeManager || userInfo.selectListManager || userInfo.workflowManager || userInfo.userManager || userInfo.docRepoManager || userInfo.smtpMailboxManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager || userInfo.productivityReports || userInfo.taskHeaderReports)"
        >
            <v-toolbar flat class="transparent">
                <v-list class="pa-0">
                    <v-list-tile avatar>
                        <v-list-tile-avatar color="secondary">
                            <v-icon dark>account_circle</v-icon>
                        </v-list-tile-avatar>
                        <v-list-tile-content>
                            <v-list-tile-title>{{ userInfo.name }} {{ userInfo.surname }}</v-list-tile-title>
                            <v-list-tile-sub-title>{{ userInfo.username}}</v-list-tile-sub-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </v-list>
            </v-toolbar>
            <v-divider></v-divider>
            <v-list dense>
                <div>
                    <div class="pa-2 grey--text text--darken-2 caption font-weight-bold">
                    Manager Screens
                </div>
                </div>
<!--Calendar Groups Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.calGroupManager)"
                        avatar
                        @click="nav('calGroupManager')"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">edit_calendar</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Calendar Groups</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Contact Management TODO Add User Options-->
              <v-list-tile
                  v-if="userInfo.entityInfo &&  userInfo.entityInfo.contactsEnabled"
                  avatar
                  @click="nav('manageContacts')"
              >
                <v-list-tile-action :tile="true">
                  <v-icon large color="primary" class="nav-item">contact_mail</v-icon>
                </v-list-tile-action>
                
                <v-list-tile-content>
                  <v-list-tile-title>Contacts</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
<!--Dataset Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.fieldsetManager)"
                        avatar

                        @click="nav('datasetSetManager')"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/icons/datasets.svg" style="width: 36px"/>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Datasets</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Document Repository Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.docRepoManager)"
                        avatar
                        @click="showDocRepoManager()"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">source</v-icon>
                        <!--<img src="../../../public/users.svg" class="nav-item" width="32px">-->
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Document Repository</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Folder Groups-->
                <v-list-tile
                        avatar
                        @click="nav('folderManager')"
                        v-if="userInfo.folderManager === 1"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/icons/user_folder.svg" style="width: 36px"/>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Folder Groups</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Mailbox Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.smtpMailboxManager)"
                        avatar
                        @click="showMailboxManger()"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">markunread_mailbox</v-icon>
                        <!--<img src="../../../public/users.svg" class="nav-item" width="32px">-->
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Group Mailboxes</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Out Of Office Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.outOfOfficeManager)"
                        avatar
                        @click="showOOOManager()"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">emoji_people</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Out Of Office</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

<!--Select List Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.selectListManager) || intToBool(userInfo.workflowManager)"
                        avatar
                        @click="showSelectList"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">list</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Select Lists</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Signature Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.signatureManager)"
                        avatar
                        @click="showSignatures"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/icons/signatures.svg" style="width: 36px"/>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Signatures</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--User Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.userManager || userInfo.workflowManager || userInfo.fieldsetManager || userInfo.folderManager)"
                        avatar
                        @click="showUserGroupManger()"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large class="primary--text" >groups</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>User Groups</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--User Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.userManager)"
                        avatar
                        @click="showUserManger()"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/users.svg" style="width: 36px"/>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Users</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Workflows Manager-->
                <v-list-tile
                        v-if="intToBool(userInfo.workflowManager)"
                        avatar
                        @click="nav('workflowEditor')"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/workflows.svg" class="nav-item" width="32px">
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Workflows</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <div>
                    <v-divider></v-divider>
                    <div class="pa-2 grey--text text--darken-2 caption font-weight-bold" v-if="userInfo.productivityReports || userInfo.taskHeaderReports">
                    Reporting
                </div>
                </div>
<!--Productivity Reports-->
                <v-list-tile
                        avatar
                        @click="nav('productivityReports')"
                        v-if="typeof userInfo.productivityReports != 'undefined' && intToBool(userInfo.productivityReports)"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">category</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Productivity Reports</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
<!--Task Header Report-->
                <v-list-tile
                        v-if="userInfo.taskHeaderReports"
                        avatar
                        @click="nav('taskHeaderReport')"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon large color="primary" class="nav-item">summarize</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Task Header Report</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <div>
                    <v-divider></v-divider>
                    <div class="pa-2 grey--text text--darken-2 caption font-weight-bold" v-if="userInfo.importManager || userInfo.tasklogixAdmin">
                    Utilities
                </div>
                </div>
<!--Importer-->
                <v-list-tile
                        avatar
                        @click="showImporter = true"
                        v-if="userInfo && typeof userInfo.importManager != 'undefined' && intToBool(userInfo.importManager)"
                >
                    <v-list-tile-action :tile="true">
                        <img src="../../../public/icons/import.svg" style="width: 36px"/>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Imports</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

                <v-list-tile
                    avatar
                    @click="showBilling = true"
                    v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin"
                >
                    <v-list-tile-action :tile="true">
                        <v-icon color="primary" large>shopping_cart</v-icon>
                    </v-list-tile-action>

                    <v-list-tile-content>
                        <v-list-tile-title>Billing Manager</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>

            </v-list>
        </v-navigation-drawer>

        <app-import-dlg
                v-if="userInfo && typeof userInfo.importManager != 'undefined' && intToBool(userInfo.importManager)"
                :user-info="userInfo"
                :show-dialog="showImporter"
                @dismiss="showImporter = false"
        />
        <app-input-dlg
                :show-dialog="showRemoveGmailAccess"
                title="Remove Gmail Account"
                body="This will remove access to your GMail account and delete your access token."
                :cancel-button="true"
                :show-input-box="false"
                :buttons="['Remove']"
                :call-backs="[ removeGmailAccess ]"
                @dismiss="showRemoveGmailAccess = false"
        />
        <app-input-dlg
                :show-dialog="showRemoveOfficeAccess"
                title="Remove Office Account"
                body="This will remove access to your Office account and delete your access token."
                :cancel-button="true"
                :show-input-box="false"
                :buttons="['Remove']"
                :call-backs="[ removeOfficeAccess ]"
                @dismiss="showRemoveOfficeAccess = false"
        />
        <app-select-list-manager
                v-if="userInfo && (intToBool(userInfo.selectListManager) || intToBool(userInfo.workflowManager))"
                :show-manager="showSelectLists"
                :selectable="false"
                :select-lists="selectLists"
                :self-load="true"
                :user-info="userInfo"
                @setSelectLists="selectLists = $event"
                @dismiss="showSelectLists = false"
        />
        <app-out-of-office-manager
                v-if="userInfo && showOutOfOfficeManager && intToBool(userInfo.outOfOfficeManager)"
                :user-info="userInfo"
                :show-manager="showOutOfOfficeManager"
                @dismiss="showOutOfOfficeManager = false"
        />

        <s-m-s-profile
                :user-info="userInfo"
                v-model="showSMSProfile"
        />

        <app-input-dlg
                v-if="showSMTPSettings"
                :show-dialog="showSMTPSettings"
                title="Configure SMTP"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showSMTPSettings = false"
                :body-padding="false"
                :width="700"
        >
            <template slot="body">
                <div class="pa-2">
                    <configure-smtp
                            :user-info="userInfo"
                    />
                </div>
            </template>
        </app-input-dlg>

        <digest-dlg
                v-if="showDigest"
                v-model="showDigest"
        />

        <app-input-dlg
                :show-dialog="showEditQuickTask"
                title="Edit Task Shortcut"
                :cancel-button="true"
                :show-input-box="false"
                @dismiss="showEditQuickTask = false"
                :body-padding="false"
                v-if="showEditQuickTask"
        >
            <template slot="body">
                <div class="pa-2">
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Task Shortcut Description:
                        </div>
                        <div :class="itemClass">
                            <v-text-field
                                    label="Description"
                                    single-line
                                    color="primary"
                                    append-outer-icon="save"
                                    hide-details
                                    style="width: 100%"
                                    class="pa-0 ma-0"
                                    ref="fieldDescription"
                                    v-model="editQuickTask.config.description"
                            ></v-text-field>
                        </div>
                    </div>
                    <div :class="topicClass">
                        <div :class="headingClass">
                            Task Shortcut Icon:
                        </div>
                        <v-menu bottom offset-y lazy v-model="qtiMenue" :close-on-content-click="false">
                            <template v-slot:activator="{ on }">
                                <div :class="itemClass" class="text-xs-center" v-on="on">
                                    <div class="text-xs-center">
                                        <v-btn
                                                large
                                                icon
                                                class="pa-0 ma-0"
                                                color="primary"
                                                flat
                                        >
                                            <v-icon large>{{editQuickTask.config.icon}}</v-icon>
                                        </v-btn>
                                    </div>
                                    <div class="text-xs-center caption greyType--text">
                                        {{editQuickTask.config.icon}}
                                    </div>
                                </div>
                            </template>

                            <v-card class="scrollable" style="max-width: 400px">
                                <div class="pa-1">
                                    <v-text-field
                                            label="Filter Icons"
                                            single-line
                                            clearable
                                            prepend-icon="search"
                                            color="primary"
                                            flat
                                            :hide-details="true"
                                            v-model="qtiFilterString"
                                            class="pa-0 ma-0"
                                    ></v-text-field>
                                </div>

                                <v-layout row wrap v-if="qtiMenue" class="scrollable" style="max-height: 300px;">
                                    <v-flex shrink
                                            v-for="viewIcon in qtiFilterString == null || qtiFilterString === '' ? icons : icons.filter(obj => obj.toLowerCase().includes(qtiFilterString.toLowerCase()))"
                                            class="text-xs-center pa-2 hover-item"
                                            :key="viewIcon"
                                            style="border-radius: 3px"
                                    >
                                        <v-icon
                                                large
                                                @click="editQuickTask.config.icon = viewIcon; qtiMenue = false"
                                                style="cursor: pointer"
                                        >
                                            {{viewIcon}}
                                        </v-icon>
                                    </v-flex>
                                </v-layout>
                            </v-card>
                        </v-menu>
                    </div>
                </div>
            </template>
            <template slot="actions">
                <v-btn
                        small
                        outline
                        color="secondary"
                        class="px-2 py-0 ma-0 mx-2"
                        :disabled="editingQuickTask"
                        @click="showEditQuickTask = false"
                >
                    Cancel
                </v-btn>

                <v-btn
                        small
                        color="secondary"
                        class="px-2 py-0 ma-0"
                        :disabled="blankString(editQuickTask.config.description) || editingQuickTask"
                        :loading="editingQuickTask"
                        @click="updateQuickTask"
                >
                    Update Task Shortcut
                </v-btn>
            </template>
        </app-input-dlg>

        <office-send-as
                v-if="userInfo && userInfo.userID && showManageSendAs"
                :user-id="userInfo.userID"
                :shown.sync="showManageSendAs"
        ></office-send-as>

        <billing-manager
            v-if="userInfo && typeof userInfo.tasklogixAdmin != 'undefined' && userInfo.tasklogixAdmin && showBilling"
            :show.sync="showBilling"
        ></billing-manager>
        
        <app-input-dlg
            v-if="showAddProfile"
            :show-dialog="showAddProfile"
            title="Add Tasklogix Profile"
            :cancel-button="true"
            :show-input-box="false"
            @dismiss="showAddProfile = false"
            :width="400"
        >
            <template slot="body">
                <v-form v-if="showAddProfile" class="px3" ref="addProfile" v-model="addProfileReady">
                    <v-text-field
                        append-icon="person_add"
                        :rules="[rules.required]"
                        @click:append="showPassword = !showPassword"
                        label="Username"
                        single-line
                        v-model="addProfileUsername"
                        color="primary"
                        style="width: 100%"
                        class="ma-0 pa-0"
                        autofocus
                    ></v-text-field>
                    <v-text-field
                        :append-icon="showPassword ? 'visibility' : 'visibility_off'"
                        :rules="[rules.required]"
                        :type="showPassword ? 'text' : 'password'"
                        @click:append="showPassword = !showPassword"
                        label="Password"
                        single-line
                        v-model="addProfilePassword"
                        color="primary"
                        style="width: 100%"
                        class="ma-0 pa-0"
                    ></v-text-field>
                </v-form>
            </template>
            
            <template slot="actions">
                <v-btn
                    small
                    outline
                    color="secondary"
                    class="px-2 py-0 ma-0 mx-2"
                    :disabled="loadingProfile"
                    @click="showAddProfile = false"
                >
                    Cancel
                </v-btn>
                
                <v-btn
                    small
                    color="secondary"
                    class="px-2 py-0 ma-0"
                    :disabled="!addProfileReady || loadingProfile"
                    :loading="loadingProfile"
                    @click="addProfile"
                >
                    Add Profile
                </v-btn>
            </template>
        </app-input-dlg>
        
    </nav>
</template>

<script>

    import {eventBus} from '../../main';
    import { codeBaseMixin } from '../../codeBaseMixin';

    import ImportDlg from '../../Admin/Importer/ImportDlg'
    import ResetPasswordDlg from "./ResetPasswordDlg";
    import InputDlg from '../General/InputDlg'
    import SelectListManager from "./SelectListManager";
    import OutOfOfficeManager from "../../Admin/Out Of Office/OutOfOfficeManager";
    import SMSProfile
        from "../../Tasks/TaskView/components/TaskViewDetail/Components/FieldTypeComponents/SMS Components/SMSProfile";
    import draggable from 'vuedraggable';
    import {arrSplice, copyText, validationRules} from "../../codeFunctions";
    import ConfigureSmtp from "../../Mail/SMTP/Configure Smtp/ConfigureSmtp";
    import SupportDialog from "./SupportDialog";
    import Announcement from "@/Announcemnts/Announcement";
    import userInfo from "@/Store/userInfo/userInfo";
    import {mapGetters} from "vuex";
    import DigestDlg from "@/components/General/DigestDlg";
    import OfficeSendAs from "@/components/General/OfficeSendAs/OfficeSendAs";
    import BillingManager from "@/Admin/Billing Manager/BillingManager.vue";
    import billingManager from "@/Admin/Billing Manager/BillingManager.vue";
    import AppBrowseContacts from "@/contacts/AppBrowseContacts.vue";
    import AppCreateLinkContact from "@/contacts/AppCreateLinkContact.vue";

    const icons = ['3d_rotation', 'ac_unit', 'access_alarm', 'access_alarms', 'access_time', 'accessibility', 'accessible', 'account_balance', 'account_balance_wallet', 'account_box', 'account_circle', 'adb', 'add', 'add_a_photo', 'add_alarm', 'add_alert', 'add_box', 'add_circle', 'add_circle_outline', 'add_location', 'add_shopping_cart', 'add_to_photos', 'add_to_queue', 'adjust', 'airline_seat_flat', 'airline_seat_flat_angled', 'airline_seat_individual_suite', 'airline_seat_legroom_extra', 'airline_seat_legroom_normal', 'airline_seat_legroom_reduced', 'airline_seat_recline_extra', 'airline_seat_recline_normal', 'airplanemode_active', 'airplanemode_inactive', 'airplay', 'airport_shuttle', 'alarm', 'alarm_add', 'alarm_off', 'alarm_on', 'album', 'all_inclusive', 'all_out', 'android', 'announcement', 'apps', 'archive', 'arrow_back', 'arrow_downward', 'arrow_drop_down', 'arrow_drop_down_circle', 'arrow_drop_up', 'arrow_forward', 'arrow_upward', 'art_track', 'aspect_ratio', 'assessment', 'assignment', 'assignment_ind', 'assignment_late', 'assignment_return', 'assignment_returned', 'assignment_turned_in', 'assistant', 'assistant_photo', 'attach_file', 'attach_money', 'attachment', 'audiotrack', 'autorenew', 'av_timer', 'backspace', 'backup', 'battery_alert', 'battery_charging_full', 'battery_full', 'battery_std', 'battery_unknown', 'beach_access', 'beenhere', 'block', 'bluetooth', 'bluetooth_audio', 'bluetooth_connected', 'bluetooth_disabled', 'bluetooth_searching', 'blur_circular', 'blur_linear', 'blur_off', 'blur_on', 'book', 'bookmark', 'bookmark_border', 'border_all', 'border_bottom', 'border_clear', 'border_color', 'border_horizontal', 'border_inner', 'border_left', 'border_outer', 'border_right', 'border_style', 'border_top', 'border_vertical', 'branding_watermark', 'brightness_1', 'brightness_2', 'brightness_3', 'brightness_4', 'brightness_5', 'brightness_6', 'brightness_7', 'brightness_auto', 'brightness_high', 'brightness_low', 'brightness_medium', 'broken_image', 'brush', 'bubble_chart', 'bug_report', 'build', 'burst_mode', 'business', 'business_center', 'cached', 'cake', 'call', 'call_end', 'call_made', 'call_merge', 'call_missed', 'call_missed_outgoing', 'call_received', 'call_split', 'call_to_action', 'camera', 'camera_alt', 'camera_enhance', 'camera_front', 'camera_rear', 'camera_roll', 'cancel', 'card_giftcard', 'card_membership', 'card_travel', 'casino', 'cast', 'cast_connected', 'center_focus_strong', 'center_focus_weak', 'change_history', 'chat', 'chat_bubble', 'chat_bubble_outline', 'check', 'check_box', 'check_box_outline_blank', 'check_circle', 'chevron_left', 'chevron_right', 'child_care', 'child_friendly', 'chrome_reader_mode', 'class', 'clear', 'clear_all', 'close', 'closed_caption', 'cloud', 'cloud_circle', 'cloud_done', 'cloud_download', 'cloud_off', 'cloud_queue', 'cloud_upload', 'code', 'collections', 'collections_bookmark', 'color_lens', 'colorize', 'comment', 'compare', 'compare_arrows', 'computer', 'confirmation_number', 'contact_mail', 'contact_phone', 'contacts', 'content_copy', 'content_cut', 'content_paste', 'control_point', 'control_point_duplicate', 'copyright', 'create', 'create_new_folder', 'credit_card', 'crop', 'crop_16_9', 'crop_3_2', 'crop_5_4', 'crop_7_5', 'crop_din', 'crop_free', 'crop_landscape', 'crop_original', 'crop_portrait', 'crop_rotate', 'crop_square', 'dashboard', 'data_usage', 'date_range', 'dehaze', 'delete', 'delete_forever', 'delete_sweep', 'description', 'desktop_mac', 'desktop_windows', 'details', 'developer_board', 'developer_mode', 'device_hub', 'devices', 'devices_other', 'dialer_sip', 'dialpad', 'directions', 'directions_bike', 'directions_boat', 'directions_bus', 'directions_car', 'directions_railway', 'directions_run', 'directions_subway', 'directions_transit', 'directions_walk', 'disc_full', 'dns', 'do_not_disturb', 'do_not_disturb_alt', 'do_not_disturb_off', 'do_not_disturb_on', 'dock', 'domain', 'done', 'done_all', 'donut_large', 'donut_small', 'drafts', 'drag_handle', 'drive_eta', 'dvr', 'edit', 'edit_location', 'eject', 'email', 'enhanced_encryption', 'equalizer', 'error', 'error_outline', 'euro_symbol', 'ev_station', 'event', 'event_available', 'event_busy', 'event_note', 'event_seat', 'exit_to_app', 'expand_less', 'expand_more', 'explicit', 'explore', 'exposure', 'exposure_neg_1', 'exposure_neg_2', 'exposure_plus_1', 'exposure_plus_2', 'exposure_zero', 'extension', 'face', 'fast_forward', 'fast_rewind', 'favorite', 'favorite_border', 'featured_play_list', 'featured_video', 'feedback', 'fiber_dvr', 'fiber_manual_record', 'fiber_new', 'fiber_pin', 'fiber_smart_record', 'file_download', 'file_upload', 'filter', 'filter_1', 'filter_2', 'filter_3', 'filter_4', 'filter_5', 'filter_6', 'filter_7', 'filter_8', 'filter_9', 'filter_9_plus', 'filter_b_and_w', 'filter_center_focus', 'filter_drama', 'filter_frames', 'filter_hdr', 'filter_list', 'filter_none', 'filter_tilt_shift', 'filter_vintage', 'find_in_page', 'find_replace', 'fingerprint', 'first_page', 'fitness_center', 'flag', 'flare', 'flash_auto', 'flash_off', 'flash_on', 'flight', 'flight_land', 'flight_takeoff', 'flip', 'flip_to_back', 'flip_to_front', 'folder', 'folder_open', 'folder_shared', 'folder_special', 'font_download', 'format_align_center', 'format_align_justify', 'format_align_left', 'format_align_right', 'format_bold', 'format_clear', 'format_color_fill', 'format_color_reset', 'format_color_text', 'format_indent_decrease', 'format_indent_increase', 'format_italic', 'format_line_spacing', 'format_list_bulleted', 'format_list_numbered', 'format_paint', 'format_quote', 'format_shapes', 'format_size', 'format_strikethrough', 'format_textdirection_l_to_r', 'format_textdirection_r_to_l', 'format_underlined', 'forum', 'forward', 'forward_10', 'forward_30', 'forward_5', 'free_breakfast', 'fullscreen', 'fullscreen_exit', 'functions', 'g_translate', 'gamepad', 'games', 'gavel', 'gesture', 'get_app', 'gif', 'golf_course', 'gps_fixed', 'gps_not_fixed', 'gps_off', 'grade', 'gradient', 'grain', 'graphic_eq', 'grid_off', 'grid_on', 'group', 'group_add', 'group_work', 'hd', 'hdr_off', 'hdr_on', 'hdr_strong', 'hdr_weak', 'headset', 'headset_mic', 'healing', 'hearing', 'help', 'help_outline', 'high_quality', 'highlight', 'highlight_off', 'history', 'home', 'hot_tub', 'hotel', 'hourglass_empty', 'hourglass_full', 'http', 'https', 'image', 'image_aspect_ratio', 'import_contacts', 'import_export', 'important_devices', 'inbox', 'indeterminate_check_box', 'info', 'info_outline', 'input', 'insert_chart', 'insert_comment', 'insert_drive_file', 'insert_emoticon', 'insert_invitation', 'insert_link', 'insert_photo', 'invert_colors', 'invert_colors_off', 'iso', 'keyboard', 'keyboard_arrow_down', 'keyboard_arrow_left', 'keyboard_arrow_right', 'keyboard_arrow_up', 'keyboard_backspace', 'keyboard_capslock', 'keyboard_hide', 'keyboard_return', 'keyboard_tab', 'keyboard_voice', 'kitchen', 'label', 'label_outline', 'landscape', 'language', 'laptop', 'laptop_chromebook', 'laptop_mac', 'laptop_windows', 'last_page', 'launch', 'layers', 'layers_clear', 'leak_add', 'leak_remove', 'lens', 'library_add', 'library_books', 'library_music', 'lightbulb_outline', 'line_style', 'line_weight', 'linear_scale', 'link', 'linked_camera', 'list', 'live_help', 'live_tv', 'local_activity', 'local_airport', 'local_atm', 'local_bar', 'local_cafe', 'local_car_wash', 'local_convenience_store', 'local_dining', 'local_drink', 'local_florist', 'local_gas_station', 'local_grocery_store', 'local_hospital', 'local_hotel', 'local_laundry_service', 'local_library', 'local_mall', 'local_movies', 'local_offer', 'local_parking', 'local_pharmacy', 'local_phone', 'local_pizza', 'local_play', 'local_post_office', 'local_printshop', 'local_see', 'local_shipping', 'local_taxi', 'location_city', 'location_disabled', 'location_off', 'location_on', 'location_searching', 'lock', 'lock_open', 'lock_outline', 'looks', 'looks_3', 'looks_4', 'looks_5', 'looks_6', 'looks_one', 'looks_two', 'loop', 'loupe', 'low_priority', 'loyalty', 'mail', 'mail_outline', 'map', 'markunread', 'markunread_mailbox', 'memory', 'menu', 'merge_type', 'message', 'mic', 'mic_none', 'mic_off', 'mms', 'mode_comment', 'mode_edit', 'monetization_on', 'money_off', 'monochrome_photos', 'mood', 'mood_bad', 'more', 'more_horiz', 'more_vert', 'motorcycle', 'mouse', 'move_to_inbox', 'movie', 'movie_creation', 'movie_filter', 'multiline_chart', 'music_note', 'music_video', 'my_location', 'nature', 'nature_people', 'navigate_before', 'navigate_next', 'navigation', 'near_me', 'network_cell', 'network_check', 'network_locked', 'network_wifi', 'new_releases', 'next_week', 'nfc', 'no_encryption', 'no_sim', 'not_interested', 'note', 'note_add', 'notifications', 'notifications_active', 'notifications_none', 'notifications_off', 'notifications_paused', 'offline_pin', 'ondemand_video', 'opacity', 'open_in_browser', 'open_in_new', 'open_with', 'pages', 'pageview', 'palette', 'pan_tool', 'panorama', 'panorama_fish_eye', 'panorama_horizontal', 'panorama_vertical', 'panorama_wide_angle', 'party_mode', 'pause', 'pause_circle_filled', 'pause_circle_outline', 'payment', 'people', 'people_outline', 'perm_camera_mic', 'perm_contact_calendar', 'perm_data_setting', 'perm_device_information', 'perm_identity', 'perm_media', 'perm_phone_msg', 'perm_scan_wifi', 'person', 'person_add', 'person_outline', 'person_pin', 'person_pin_circle', 'personal_video', 'pets', 'phone', 'phone_android', 'phone_bluetooth_speaker', 'phone_forwarded', 'phone_in_talk', 'phone_iphone', 'phone_locked', 'phone_missed', 'phone_paused', 'phonelink', 'phonelink_erase', 'phonelink_lock', 'phonelink_off', 'phonelink_ring', 'phonelink_setup', 'photo', 'photo_album', 'photo_camera', 'photo_filter', 'photo_library', 'photo_size_select_actual', 'photo_size_select_large', 'photo_size_select_small', 'picture_as_pdf', 'picture_in_picture', 'picture_in_picture_alt', 'pie_chart', 'pie_chart_outlined', 'pin_drop', 'place', 'play_arrow', 'play_circle_filled', 'play_circle_outline', 'play_for_work', 'playlist_add', 'playlist_add_check', 'playlist_play', 'plus_one', 'poll', 'polymer', 'pool', 'portable_wifi_off', 'portrait', 'power', 'power_input', 'power_settings_new', 'pregnant_woman', 'present_to_all', 'print', 'priority_high', 'public', 'publish', 'query_builder', 'question_answer', 'queue', 'queue_music', 'queue_play_next', 'radio', 'radio_button_checked', 'radio_button_unchecked', 'rate_review', 'receipt', 'recent_actors', 'record_voice_over', 'redeem', 'redo', 'refresh', 'remove', 'remove_circle', 'remove_circle_outline', 'remove_from_queue', 'remove_red_eye', 'remove_shopping_cart', 'reorder', 'repeat', 'repeat_one', 'replay', 'replay_10', 'replay_30', 'replay_5', 'reply', 'reply_all', 'report', 'report_problem', 'restaurant', 'restaurant_menu', 'restore', 'restore_page', 'ring_volume', 'room', 'room_service', 'rotate_90_degrees_ccw', 'rotate_left', 'rotate_right', 'rounded_corner', 'router', 'rowing', 'rss_feed', 'rv_hookup', 'satellite', 'save', 'scanner', 'schedule', 'school', 'screen_lock_landscape', 'screen_lock_portrait', 'screen_lock_rotation', 'screen_rotation', 'screen_share', 'sd_card', 'sd_storage', 'search', 'security', 'select_all', 'send', 'sentiment_dissatisfied', 'sentiment_neutral', 'sentiment_satisfied', 'sentiment_very_dissatisfied', 'sentiment_very_satisfied', 'settings', 'settings_applications', 'settings_backup_restore', 'settings_bluetooth', 'settings_brightness', 'settings_cell', 'settings_ethernet', 'settings_input_antenna', 'settings_input_component', 'settings_input_composite', 'settings_input_hdmi', 'settings_input_svideo', 'settings_overscan', 'settings_phone', 'settings_power', 'settings_remote', 'settings_system_daydream', 'settings_voice', 'share', 'shop', 'shop_two', 'shopping_basket', 'shopping_cart', 'short_text', 'show_chart', 'shuffle', 'signal_cellular_4_bar', 'signal_cellular_connected_no_internet_4_bar', 'signal_cellular_no_sim', 'signal_cellular_null', 'signal_cellular_off', 'signal_wifi_4_bar', 'signal_wifi_4_bar_lock', 'signal_wifi_off', 'sim_card', 'sim_card_alert', 'skip_next', 'skip_previous', 'slideshow', 'slow_motion_video', 'smartphone', 'smoke_free', 'smoking_rooms', 'sms', 'sms_failed', 'snooze', 'sort', 'sort_by_alpha', 'spa', 'space_bar', 'speaker', 'speaker_group', 'speaker_notes', 'speaker_notes_off', 'speaker_phone', 'spellcheck', 'star', 'star_border', 'star_half', 'stars', 'stay_current_landscape', 'stay_current_portrait', 'stay_primary_landscape', 'stay_primary_portrait', 'stop', 'stop_screen_share', 'storage', 'store', 'store_mall_directory', 'straighten', 'streetview', 'strikethrough_s', 'style', 'subdirectory_arrow_left', 'subdirectory_arrow_right', 'subject', 'subscriptions', 'subtitles', 'subway', 'supervisor_account', 'surround_sound', 'swap_calls', 'swap_horiz', 'swap_vert', 'swap_vertical_circle', 'switch_camera', 'switch_video', 'sync', 'sync_disabled', 'sync_problem', 'system_update', 'system_update_alt', 'tab', 'tab_unselected', 'tablet', 'tablet_android', 'tablet_mac', 'tag_faces', 'tap_and_play', 'terrain', 'text_fields', 'text_format', 'textsms', 'texture', 'theaters', 'thumb_down', 'thumb_up', 'thumbs_up_down', 'time_to_leave', 'timelapse', 'timeline', 'timer', 'timer_10', 'timer_3', 'timer_off', 'title', 'toc', 'today', 'toll', 'tonality', 'touch_app', 'toys', 'track_changes', 'traffic', 'train', 'tram', 'transfer_within_a_station', 'transform', 'translate', 'trending_down', 'trending_flat', 'trending_up', 'tune', 'turned_in', 'turned_in_not', 'tv', 'unarchive', 'undo', 'unfold_less', 'unfold_more', 'update', 'usb', 'verified_user', 'vertical_align_bottom', 'vertical_align_center', 'vertical_align_top', 'vibration', 'video_call', 'video_label', 'video_library', 'videocam', 'videocam_off', 'videogame_asset', 'view_agenda', 'view_array', 'view_carousel', 'view_column', 'view_comfy', 'view_compact', 'view_day', 'view_headline', 'view_list', 'view_module', 'view_quilt', 'view_stream', 'view_week', 'vignette', 'visibility', 'visibility_off', 'voice_chat', 'voicemail', 'volume_down', 'volume_mute', 'volume_off', 'volume_up', 'vpn_key', 'vpn_lock', 'wallpaper', 'warning', 'watch', 'watch_later', 'wb_auto', 'wb_cloudy', 'wb_incandescent', 'wb_iridescent', 'wb_sunny', 'wc', 'web', 'web_asset', 'weekend', 'whatshot', 'widgets', 'wifi', 'wifi_lock', 'wifi_tethering', 'work', 'wrap_text', 'youtube_searched_for', 'zoom_in', 'zoom_out', 'zoom_out_map'];

    export default {
        components: {
          AppCreateLinkContact,
          AppBrowseContacts,
            BillingManager,
            OfficeSendAs,
            DigestDlg,
            Announcement,
            SupportDialog,
            ConfigureSmtp,
            draggable,
            SMSProfile,
            appOutOfOfficeManager: OutOfOfficeManager,
            appSelectListManager: SelectListManager,
            appResetPasswordDlg: ResetPasswordDlg,
            appImportDlg: ImportDlg,
            appInputDlg: InputDlg,
        },
        mixins: [
            codeBaseMixin
        ],
        data() {
            return {
                copyText,
                document,
                drawer: false,
                page: 'Dashboard',
                showImporter : false,
                notificationCount: 0,
                showResetPassword: false,
                showReports: false,
                showRemoveGmailAccess: false,
                showRemoveOfficeAccess: false,
                showSelectLists: false,
                selectLists: [],
                showOutOfOfficeManager: false,
                settingOOO: false,
                settingComs: false,
                showSMSProfile: false,
                changingOrder: false,
                settingStarOnCreate: false,
                settingfollowOnCreate: false,
                settingTaskViewVer: false,
                showSMTPSettings: false,
                showDigest: false,
                showEditQuickTask: false,
                editQuickTask: null,
                editingQuickTask: false,
                qtiFilterString: null,
                qtiMenue: false,
                icons,
                showManageSendAs: false,
                showBilling: false,
                showAddProfile: false,
                addProfileUsername: null,
                addProfilePassword: null,
                showPassword: false,
                rules: {
                    required: value => !!value || 'Required.',
                    min: v => v.length >= 6 || 'Min 6 characters',
                    lower: v => v != null && (/[a-z]/.test(v)) || 'At Least 1 Lower Case Character Is Required',
                    upper: v => v != null && (/[A-Z]/.test(v)) || 'At Least 1 Upper Case Character Is Required',
                    special: v => v != null && (/[$&+,:;=?@#|'<>.^*()%!-]/.test(v)) || 'At Least 1 Special Character Is Required',
                },
                addProfileReady: null,
                loadingProfile: false
            }
        },
        methods: {

            oPlugCopyUrl() {
                const url = `${window.location.protocol}//${window.location.host}/oPlug/${window.location.hostname.split('.').shift()}Manifest.xml`
                this.copyText(document, url);
                this.$snack.info('Autolink Address Copied')
            },

            updateQuickTask() {
                this.editingQuickTask = true;
                this.fetch({method: 'POST', url:`/tasks/quickTask/add/Edit/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(this.editQuickTask)})
                        .then((data) => {
                            arrSplice(this.userInfo.quickTasks, (qt) => qt.id === this.editQuickTask.id)
                            this.userInfo.quickTasks.push(this.editQuickTask)
                            this.editQuickTask = null;
                            this.showEditQuickTask = false;
                            this.showSnack('Info', 'Task Shortcut Modified', 'Close', 'primary')
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e);
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                            this.addingQuickTask = false;
                        })
                        .finally(() => {
                            this.editingQuickTask = false;
                        })
            },

            updateO365AutoLink(value) {
                this.$newReq('POST', `users/updateO365AutoLink/${this.userInfo.entityID}/${this.userInfo.userID}/${value ? 1 : 0}`)
                    .then(() => {
                        this.userInfo.office365Autolink = value ? 1 : 0;
                        this.$snack.info('Changes Saved')
                    })
                    .catch(console.log)
            },

            showMailboxManger() {
                eventBus.$emit('navEvent', 'smtpMailboxManager')
            },

            showDocRepoManager() {
                eventBus.$emit('navEvent', 'docRepoManager')
            },

            showUserGroupManger() {
                eventBus.$emit('navEvent', 'userGroupManger')
            },

            showUserManger() {
                eventBus.$emit('navEvent', 'userManger')
            },

            updateStarOnCreate(val) {
                this.settingStarOnCreate = true;
                this.fetch({method: 'PATCH', url:`/localUsers/starOnCreate/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`})
                    .then(() => {
                        this.settingStarOnCreate = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.userInfo.starOnCreate = 0;
                        this.settingStarOnCreate = false;
                    });
            },

            updateFollowOnCreate(val) {
                this.followStarOnCreate = true;
                this.fetch({method: 'PATCH', url:`/localUsers/followOnCreate/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`})
                    .then(() => {
                        this.followStarOnCreate = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.userInfo.followOnCreate = 0;
                        this.followStarOnCreate = false;
                    });
            },

            updateTaskViewVer(val) {
                this.settingTaskViewVer = true;
                this.fetch({method: 'PATCH', url:`/localUsers/taskViewVer/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(val)}`})
                    .then(() => {
                        this.settingTaskViewVer = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.userInfo.taskView = 0;
                        this.settingTaskViewVer = false;
                    });
            },

            removeQuick(qTask) {
                this.changingOrder = true;
                this.fetch({method: 'POST', url:`/tasks/quickTask/remove/${this.userInfo.entityID}/${this.userInfo.userID}/${qTask.id}`})
                    .then(() => {
                        arrSplice(this.userInfo.quickTasks, (obj) => obj.id === qTask.id);
                        this.showSnack('Info', 'Quick Task Removed', 'Close', 'primary')
                        this.changingOrder = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.changingOrder = false;
                    });
            },

            log(event) {

                let tArr = [];

                Object.assign(tArr, this.sortedQuickTasks)

                tArr.splice(event.moved.oldIndex, 1, null)

                if (event.moved.oldIndex > event.moved.newIndex) {
                    tArr.splice(event.moved.newIndex, 0, event.moved.element)
                } else {
                    tArr.splice(event.moved.newIndex + 1, 0, event.moved.element)
                }

                tArr = tArr.filter(obj => obj !== null);

                let updateBody = tArr
                    .map((obj, index) => {
                        let tConfig = {}
                        Object.assign(tConfig, obj.config)
                        tConfig.order = index
                        return {id: obj.id, config: tConfig}
                    });
                this.changingOrder = true;
                this.fetch({method: 'POST', url:`/tasks/quickTask/order/update/${this.userInfo.entityID}/${this.userInfo.userID}`, body: JSON.stringify(updateBody)})
                    .then(() => {
                        this.userInfo.quickTasks.forEach(qt => {
                            qt.config.order = updateBody.filter(obj => obj.id === qt.id).map(obj => {return obj.config.order}).pop()
                        });
                        this.showSnack('Info', 'Order Updated', 'Close', 'primary')
                        this.changingOrder = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.changingOrder = false;
                    });

            },

            quickTaskRun(workflow, folder) {
                // TODO FILTER and load quick tasks from user info
                eventBus.$emit('quickTask', {workflow: workflow, folder: folder})

            },

            resetSyncStatus() {
                eventBus.$emit('resetSyncStat')
            },

            setOutOfOffice(value) {
                this.settingOOO = true;
                this.fetch({method: 'GET', url:`/localUsers/OOO/setUser/${this.userInfo.entityID}/${this.userInfo.userID}/${this.boolToInt(!this.intToBool(this.userInfo.outOfOffice))}`})
                    .then(() => {
                        this.userInfo.outOfOffice = this.boolToInt(!this.intToBool(this.userInfo.outOfOffice));
                        eventBus.$emit('OOOSet', this.userInfo.outOfOffice)
                        this.settingOOO = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        this.settingOOO = false;
                        console.log(e);
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.$refs.outOfOfficeSwitch.value = this.intToBool(this.userInfo.outOfOffice)
                    })
            },
            oldFieldSetManager() {
                eventBus.$emit('showFieldSetEditor')
            },
            showOOOManager() {
                this.drawer = false;
                this.showOutOfOfficeManager = true;
            },

            showSelectList() {
                this.drawer = false;
                this.showSelectLists = true;
            },

            removeGmailAccess() {
                this.fetch({method: 'GET', url:`/gmail/auth/LogoutandRemoveAccess/${this.userInfo.userID}`})
                    .then((data) => {
                        eventBus.$emit('gmailAccountRemoved');
                        this.showSnack('Info', 'Gmail Account Removed', 'Close', 'primary');
                        this.showRemoveGmailAccess = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.showRemoveGmailAccess = false;
                    })
            },

            removeOfficeAccess() {
                this.fetch({method: 'GET', url:`/office/auth/removeToken/${this.userInfo.userID}`})
                    .then((data) => {
                        eventBus.$emit('officeAccountRemoved');
                        this.showSnack('Info', 'Office Account Removed', 'Close', 'primary');
                        this.showRemoveOfficeAccess = false;
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red');
                        this.showRemoveOfficeAccess = false;
                    })
            },

            resetPassword(password) {
                if (password != null && password != '') {

                    this.showResetPassword = false;

                    this.fetch({method: 'PATCH', url: '/localUsers/setPassword/' + this.userInfo.entityID + '/' + this.userInfo.userID, body: JSON.stringify({password: password, username: this.userInfo.username})})
                        .then(() => {
                            this.showSnack('Info', 'Password Has Been Changed', 'Close', 'primary')
                        })
                        .catch((e) => {
                            // eslint-disable-next-line
                            console.log(e)
                            this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                        })

                    // showSetPassword
                } else {
                    this.showSnack('Error', 'Password Can Not Be Blank', 'Close', 'red')
                }
            },

            showFieldSetEditor() {
                this.drawer = false;
                eventBus.$emit('showFieldSetEditor', true);
            },

            showGmailMailbox() {
                this.drawer = false;
                eventBus.$emit('showGroupMailboxManager', true);
            },

            showSignatures() {
                this.drawer = false;
                eventBus.$emit('signatureManager', true);
            },
            nav(navTo) {
                this.drawer = false;
                eventBus.$emit('navEvent', navTo);
            },
            logOff() {

                this.fetch({method: 'DELETE', url:`/login/logout`})
                    .then(() => {
                        eventBus.$emit('showHideNav', false);
                    })
                    .catch((e) => {
                        // eslint-disable-next-line
                        console.log(e)
                        this.showSnack('Error', 'Network error. Please try again.', 'Close', 'red')
                    });
            },
            notificationCountUpdate(amount) {this.notificationCount = amount;document.title = `Tasklogix (${amount})`;},
            navEvent(navTo) {
                switch (navTo) {
                    case 'gmail': {
                        this.page = 'Gmail';
                        break;
                    }
                    case 'office365': {
                        this.page = 'Office 365';
                        break;
                    }
                    case 'dashboard': {
                        this.page = 'Dashboard';
                        eventBus.$emit('DashboardShown');
                        break;
                    }
                    case 'tasks': {
                        this.page = 'Tasks';
                        eventBus.$emit('TasksScreenShown');
                        break;
                    }
                }
            },
            
            async gotoProfile(profile) {
                if (!profile.active)
                    try {
                        this.loadingProfile = true;
                        const {token, userKey, exp} = await this.$newReq('POST', `users/switchProfile`, profile)
                        console.log(window.location)
                        
                        var currentUrl = window.location.href;
                        var url = new URL(currentUrl);
                        
                        // Set new query parameters
                        url.searchParams.set('user_key', userKey);
                        url.searchParams.set('token', token);
                        url.searchParams.set('exp', exp);
                        
                        // Reload the page with the new URL
                        window.location.href = url.href;
                        
                        this.showAddProfile = false
                    } catch (e) {
                        console.log(e)
                    } finally {
                        this.loadingProfile = false;
                    }
            },
            
            async removeProfile(profile) {
                try {
                    this.loadingProfile = true;
                    await this.$newReq('POST', `users/removeProfile`, profile)
                    arrSplice(this.userInfo.userProfiles, pro => pro.userId === profile.userId)
                    this.showAddProfile = false
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loadingProfile = false;
                }
            },
            
            async addProfile() {
                try {
                    this.loadingProfile = true;
                    const res = await this.$newReq('POST', `users/addProfile`, {
                        from: this.profiles.find(pro => pro.active),
                        to: {
                            username: this.addProfileUsername,
                            password: this.addProfilePassword
                        }
                    })
                    
                    if (res.error)
                        return this.$snack.error(res.message)
                    
                    
                    this.$set(this.userInfo, "userProfiles", res)
                    this.showAddProfile = false
                        
                } catch (e) {
                    console.log(e)
                } finally {
                    this.loadingProfile = false;
                }
            }
        },

        created() {
            eventBus.$on('notificationCountUpdate', this.notificationCountUpdate);

            eventBus.$on('navEvent', this.navEvent)
        },
        beforeDestroy() {
            eventBus.$off('notificationCountUpdate', this.notificationCountUpdate);
            eventBus.$off('navEvent', this.navEvent)
        },
        computed: {
            billingManager() {
                return billingManager
            },

            ...mapGetters('userInfo', ['userInfo', 'softBlock']),

            starOnCreate: {
                get() {
                    return this.intToBool(this.userInfo.starOnCreate)
                },
                set(val) {
                    this.userInfo.starOnCreate = this.boolToInt(val);
                    this.updateStarOnCreate(val);
                }
            },

            followOnCreate: {
                get() {
                    return this.intToBool(this.userInfo.followOnCreate)
                },
                set(val) {
                    this.userInfo.followOnCreate = this.boolToInt(val);
                    this.updateFollowOnCreate(val);
                }
            },

            taskViewVer: {
                get() {
                    return this.intToBool(this.userInfo.taskView)
                },
                set(val) {
                    this.userInfo.taskView = this.boolToInt(val);
                    this.updateTaskViewVer(val);
                }
            },


            sortedQuickTasks() {
                return this.userInfo.quickTasks.filter(() => true).sort((a,b) => a['config']['order'] < b['config']['order'] ? -1 : 1);
            },

            outOfOffice: {
                get() {
                    if (typeof this.userInfo.outOfOffice != 'undefined') {
                        return this.intToBool(this.userInfo.outOfOffice)
                    } else {
                        return false;
                    }
                },
                set(value) {
                    this.setOutOfOffice(value)
                }
            },
            
            profiles() {
                
                if (!this.userInfo || !this.userInfo.userProfiles || !Array.isArray(this.userInfo.userProfiles))
                    return [];
                
                let profiles = [...this.userInfo.userProfiles]
                
                if (!profiles.find(pro => pro.userId === this.userInfo.userID)) {
                    profiles.push({
                        userId: this.userInfo.userID,
                        username: this.userInfo.username,
                        userName: `${this.userInfo.name} ${this.userInfo.surname}`.trim(),
                        entityId: this.userInfo.entityID,
                        entityName: this.userInfo.entityDesc,
                        userDisabled: 0,
                        entityDisabled: 0
                    })
                }
                
                profiles = profiles.map(pro => {
                    return {...pro, active: pro.userId === this.userInfo.userID}
                })
                
                profiles.sort((a,b) => {
                    if (a.active)
                        return -1
                    if (b.active)
                        return 1
                    return a.userName > b.userName ? 1 : -1
                }).filter(profile => !(profile.userDisabled || profile.entityDisabled))
                
                return profiles
            }
        }
    }
</script>

<style scoped>

    .nav-item {
        cursor: pointer;
    }

    /*.nav-item:hover {*/
    /*border-radius: 2px;*/
    /*background: #00aa9c;*/
    /*}*/

    .reflow-image {
        width: 100%;
        height: auto;
        margin-top: auto;
    }


</style>
